import React from 'react';
import { Box } from 'grommet';
import { MaskedInput } from 'shared/controls';
import { hoursMinutes } from 'shared/constants/masks';

export function HoursValue() {
  return (
    <Box width="small" margin={{ bottom: 'small' }}>
      <MaskedInput
        box={{
          width: 'small',
          margin: {
            bottom: 'small',
          },
        }}
        size="small"
        mask={hoursMinutes}
        name="hoursValue"
      />
    </Box>
  );
}
